import { IPipeline } from "./types";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default abstract class Pipeline<InType> implements IPipeline {
    private next: IPipeline;

    private cache: Array<any> = [];

    async push(input: InType): Promise<void> {
        const output = await this.process(input);

        // 如果返回值为null就中断流程
        if (output === null) {
            return;
        }

        if (this.next) {
            this.next.push(output);
        } else {
            this.cache.push(output);
        }
    }

    abstract process(input: InType): any | Promise<any>;

    pipe(next: IPipeline): IPipeline {
        this.next = next;

        if (this.cache.length > 0) {
            while (this.cache.length > 0) {
                this.next.push(this.cache.shift());
            }
        }

        return next;
    }
}
